import { hasWindow } from "@litres/utils";

const BASE_URL = "https://api.litres.ru";

export const determineApiUrlBasedOnTLD = (hostname: string) => {
  const domainParts = hostname.split(".");
  const tld = domainParts.pop();
  const mainDomain = domainParts.join(".");

  const baseDomain = BASE_URL.replace(/\.[^/.]+$/, "");

  if (hostname.endsWith("litres-tr.com")) {
    return `${baseDomain}-tr.com`;
  }

  if (tld && (mainDomain.includes("litres") || mainDomain.includes("fbhub"))) {
    return `${baseDomain}.${tld}`;
  }

  return BASE_URL;
};

export const getTrackerApiUrl = () => {
  if (process.env.NEXT_PUBLIC_API_URL) {
    return `${process.env.NEXT_PUBLIC_API_URL}/tracker/api/event/`;
  }

  if (hasWindow) {
    return `${determineApiUrlBasedOnTLD(window.location.hostname)}/tracker/api/event/`;
  }

  return `${BASE_URL}/tracker/api/event/`;
};
